// Gerador de Assinatura de E-mail — migração de webforms-extranet/WebImob2015/Assinatura.aspx.

// Unidades ativas — preserva os 'value' do legado (mapeiam {id}.jpg no backend).
// Removidas: 6 (S. Sebastião do Paraíso/MG) e 7 (Mineiros/GO). 4 (Guaxupé) já comentada no legado.
export const UNIDADES = [
  { id: 1, label: 'Sede - São José do Rio Preto/SP' },
  { id: 8, label: 'Sede - SJRP - Cobrança' },
  { id: 3, label: 'Sede – Central de vendas' },
  { id: 2, label: 'Filial - São José dos Campos/SP' },
  { id: 5, label: 'Filial – Pouso Alegre/MG' },
  { id: 9, label: 'Filial – Rondonópolis/MT' },
];

// Unidade "Cobrança" (SJRP) não exibe o bloco de contato (RN do legado).
export const UNIDADE_SEM_CONTATO = 8;

// Dimensões fixas da arte (650 x 200; legado era 653 x 200).
export const LARGURA_ARTE = 650;
export const ALTURA_ARTE = 200;
